<script setup>
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import SalesFiltersPrimary from './SalesFiltersPrimary.vue';
import SalesFiltersSecondary from './SalesFiltersSecondary.vue';

const props = defineProps({
  activeList: { type: String, default: 'rascunhos' },
  agents: { type: Array, default: () => [] },
  filters: { type: Object, required: true },
  postSaleStatuses: { type: Array, default: () => [] },
  visible: { type: Boolean, default: true },
});

const emit = defineEmits(['apply', 'clear']);
const { t } = useI18n();
const draft = ref({ ...props.filters });
const secondaryFiltersVisible = computed(() =>
  ['entregues', 'revisoes'].includes(props.activeList)
);

watch(
  () => props.filters,
  value => {
    draft.value = { ...value };
  },
  { deep: true }
);

const toggle = ({ key, value }) => {
  const normalizedValue = String(value);
  const values = new Set((draft.value[key] || []).map(String));
  if (values.has(normalizedValue)) values.delete(normalizedValue);
  else values.add(normalizedValue);
  draft.value = { ...draft.value, [key]: [...values] };
};
const updateQuery = value => {
  draft.value = { ...draft.value, q: value };
};
const apply = () => emit('apply', { ...draft.value });
const clear = () => emit('clear');
</script>

<template>
  <section
    v-show="visible"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <SalesFiltersPrimary
      :active-list="activeList"
      :agents="agents"
      :filters="draft"
      :post-sale-statuses="postSaleStatuses"
      :query="draft.q"
      @toggle="toggle"
      @update-query="updateQuery"
      @submit="apply"
    />
    <SalesFiltersSecondary
      v-if="secondaryFiltersVisible"
      :active-list="activeList"
      :filters="draft"
      @toggle="toggle"
    />
    <div class="mt-4 flex justify-end gap-2">
      <LaisPrimaryButton variant="ghost" @click="clear">
        {{ t('SALES.ACTIONS.CLEAR') }}
      </LaisPrimaryButton>
      <LaisPrimaryButton @click="apply">
        {{ t('SALES.ACTIONS.APPLY') }}
      </LaisPrimaryButton>
    </div>
  </section>
</template>
